var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"credit-info"},[_vm._v("\n    Рассрочка "),_c('span',{staticClass:"money"},[_c('span',{staticClass:"currency"},[_vm._v(_vm._s(_vm._f("money")(_vm.displayPrice)))])]),_vm._v(" x "+_vm._s(_vm.month)+"\n    ")])
}
var staticRenderFns = []

export { render, staticRenderFns }